import { ArrayUtils, Utils } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { KamisadoBoard } from './KamisadoBoard';
import { KamisadoMove } from './KamisadoMove';
import { KamisadoRules } from './KamisadoRules';
export class KamisadoMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const state = node.gameState;
        const movablePieces = KamisadoRules.getMovablePieces(state);
        if (movablePieces.length === 0) {
            // No move, player can only pass
            // Still these are not called after the game is ended
            Utils.assert(state.alreadyPassed === false, 'getListMovesFromState should not be called once game is ended.');
            return [KamisadoMove.PASS];
        }
        else {
            const moves = this.getListMovesFromNonBlockedState(state, movablePieces);
            ArrayUtils.sortByDescending(moves, (move) => move.getDistance());
            return moves;
        }
    }
    getListMovesFromNonBlockedState(state, movablePieces) {
        // There are moves, compute them
        const moves = [];
        const player = state.getCurrentPlayer();
        // Get all the pieces that can play
        for (const startCoord of movablePieces) {
            // For each piece, look at all positions where it can go
            for (const dir of KamisadoRules.playerDirections(player)) {
                // For each direction, create a move of i in that direction
                for (let stepSize = 1; stepSize < KamisadoBoard.SIZE; stepSize++) {
                    const endCoord = startCoord.getNext(dir, stepSize);
                    if (state.isEmptyAt(endCoord)) {
                        // Check if the move can be done, and if so,
                        // add the resulting state to the map to be returned
                        const move = KamisadoMove.of(startCoord, endCoord);
                        moves.push(move);
                    }
                    else {
                        break;
                    }
                }
            }
        }
        return moves;
    }
}
